module.exports = __webpack_public_path__ + "static/media/battle-goal-box.77c6a8a6.png";